export default __webpack_public_path__ + "static/banner-be1fcfc8ffaab2bad03ca55eb822f29c.png";